import { Directive, HostListener, Input } from '@angular/core';
import { TrackingService } from './../../services/tracking/tracking.service';

/**
 * Uses the TrackingService also provided by this library to track click events.
 */
@Directive({ selector: '[oscTrackClick]' })
export class TrackClickDirective {
    private event: string | null = null;

    /**
     * Dot notation path to the event to be tracked on click.
     * In case you need to track an event by its name and not by its path, use
     * the [trackEventFromExpression]{@link TrackClickDirective#trackEventFromExpression} input.
     */
    @Input('oscTrackClick') public set trackEventFromDotNotation(dotNotationPath: string) {
        this.event = this.trackingService.getEventByPath(dotNotationPath);
    }

    /**
     * Literal event name to track on click.
     */
    @Input() public set trackEventFromExpression(event: string | null) {
        this.event = event;
    }

    public constructor(private trackingService: TrackingService) {}

    @HostListener('click')
    protected onClick() {
        if (this.event) {
            this.trackingService.trackEvent(this.event);
        }
    }
}
